export function GreekWatermark({ letter = "Ε", className = "" }) {
  return (
    <span
      aria-hidden="true"
      className={`pointer-events-none select-none absolute font-accent text-gold/[0.07] leading-none -z-10 ${className}`}
      style={{ fontSize: "clamp(7rem, 22vw, 20rem)" }}
    >
      {letter}
    </span>
  );
}
